export const GADGET_TYPES = [
  "Смартфон",
  "Ноутбук",
  "Планшет",
  "Телевізор",
  "Ігрова консоль",
  "Смарт-годинник",
  "Навушники",
  "Камера",
  "Аксесуари",
];

const BRANDS_BY_TYPE = {
  "Смартфон": ["Apple","Samsung","Xiaomi","Huawei","OnePlus","Google","Realme","OPPO","Nokia","Sony"],
  "Ноутбук": ["Apple","ASUS","Acer","Lenovo","HP","Dell","MSI","Razer","Samsung","Huawei"],
  "Планшет": ["Apple","Samsung","Lenovo","Xiaomi","Huawei","Amazon"],
  "Телевізор": ["Samsung","LG","Sony","Philips","TCL","Hisense","Xiaomi"],
  "Ігрова консоль": ["Sony","Microsoft","Nintendo","Valve"],
  "Смарт-годинник": ["Apple","Samsung","Garmin","Xiaomi","Huawei","Amazfit"],
  "Навушники": ["Apple","Sony","Sennheiser","JBL","Beats","Samsung","Bose","Xiaomi"],
  "Камера": ["Canon","Nikon","Sony","Fujifilm","Panasonic","Olympus","Leica"],
};

const MODELS_SMARTPHONE = {
  Apple: ["iPhone 11","iPhone 12","iPhone 13","iPhone 14","iPhone 15","Інше / Ввести вручну"],
  Samsung: ["Galaxy S22","Galaxy S23","Galaxy A54","Galaxy A34","Galaxy Z Flip","Інше / Ввести вручну"],
  Xiaomi: ["Redmi Note 12","Redmi Note 13","Mi 11","Mi 12","Poco X5","Інше / Ввести вручну"],
  Huawei: ["P30","P40","P50","Mate 40","Nova 11","Інше / Ввести вручну"],
  OnePlus: ["8T","9","10 Pro","Nord 2","Nord 3","Інше / Ввести вручну"],
  Google: ["Pixel 6","Pixel 6a","Pixel 7","Pixel 7a","Pixel 8","Інше / Ввести вручну"],
  OPPO: ["Reno 8","Reno 10","A78","Find X5","Інше / Ввести вручну"],
  Realme: ["GT Neo 3","10 Pro","C55","Narzo 60","Інше / Ввести вручну"],
  Nokia: ["G21","G22","X30","C32","Інше / Ввести вручну"],
  Sony: ["Xperia 10","Xperia 1","Xperia 5","Інше / Ввести вручну"],
};

const MODELS_LAPTOP = {
  Apple: ["MacBook Air","MacBook Pro 13","MacBook Pro 14","MacBook Pro 16","Інше / Ввести вручну"],
  ASUS: ["ZenBook","VivoBook","ROG Strix","TUF Gaming","Інше / Ввести вручну"],
  Acer: ["Swift","Aspire","Nitro","Predator","Інше / Ввести вручну"],
  Lenovo: ["ThinkPad","IdeaPad","Legion","Yoga","Інше / Ввести вручну"],
  HP: ["Pavilion","Envy","Victus","Omen","EliteBook","Інше / Ввести вручну"],
  Dell: ["Inspiron","XPS","G-series","Latitude","Інше / Ввести вручну"],
  MSI: ["Modern","Prestige","Gaming","Stealth","Інше / Ввести вручну"],
  Razer: ["Blade 14","Blade 15","Blade 16","Інше / Ввести вручну"],
  Samsung: ["Galaxy Book","Galaxy Book Pro","Інше / Ввести вручну"],
  Huawei: ["MateBook D","MateBook X","Інше / Ввести вручну"],
};

const MODELS_TABLET = {
  Apple: ["iPad 9","iPad 10","iPad Air","iPad Pro 11","iPad Pro 12.9","Інше / Ввести вручну"],
  Samsung: ["Galaxy Tab A8","Galaxy Tab S7","Galaxy Tab S8","Інше / Ввести вручну"],
  Lenovo: ["Tab M10","Tab P11","Yoga Tab","Інше / Ввести вручну"],
  Xiaomi: ["Pad 5","Pad 6","Інше / Ввести вручну"],
  Huawei: ["MatePad 11","MatePad Pro","Інше / Ввести вручну"],
  Amazon: ["Fire 7","Fire HD 8","Fire HD 10","Інше / Ввести вручну"],
};

const MODELS_TV = {
  Samsung: ["Q60","Q70","Q80","The Frame","Crystal UHD","Інше / Ввести вручну"],
  LG: ["C2","C3","G2","G3","NanoCell","Інше / Ввести вручну"],
  Sony: ["Bravia X","Bravia A (OLED)","Інше / Ввести вручну"],
  Philips: ["Ambilight PUS","OLED+","Інше / Ввести вручну"],
  TCL: ["C735","C835","C845","Інше / Ввести вручну"],
  Hisense: ["U7","U8","A7","Інше / Ввести вручну"],
  Xiaomi: ["Mi TV P1","Mi TV A2","Інше / Ввести вручну"],
};

const MODELS_CONSOLE = {
  Sony: ["PlayStation 4","PlayStation 5","Інше / Ввести вручну"],
  Microsoft: ["Xbox One","Xbox Series S","Xbox Series X","Інше / Ввести вручну"],
  Nintendo: ["Switch","Switch OLED","Switch Lite","Інше / Ввести вручну"],
  Valve: ["Steam Deck","Інше / Ввести вручну"],
};

const MODELS_WATCH = {
  Apple: ["Watch SE","Watch Series 7","Watch Series 8","Watch Series 9","Watch Ultra","Інше / Ввести вручну"],
  Samsung: ["Galaxy Watch 4","Galaxy Watch 5","Galaxy Watch 6","Інше / Ввести вручну"],
  Garmin: ["Fenix 7","Venu 2","Forerunner 255","Інше / Ввести вручну"],
  Xiaomi: ["Watch S1","Watch S2","Redmi Watch 3","Інше / Ввести вручну"],
  Huawei: ["Watch GT 3","Watch 3 Pro","Інше / Ввести вручну"],
  Amazfit: ["GTR 3","GTR 4","T-Rex 2","Інше / Ввести вручну"],
};

const MODELS_HEADPHONES = {
  Apple: ["AirPods 2","AirPods 3","AirPods Pro","AirPods Max","Інше / Ввести вручну"],
  Sony: ["WH-1000XM4","WH-1000XM5","WF-1000XM4","WF-1000XM5","Інше / Ввести вручну"],
  Sennheiser: ["HD 600","HD 660S","Momentum 3","Momentum 4","Інше / Ввести вручну"],
  JBL: ["Tune","Live","Quantum","Інше / Ввести вручну"],
  Beats: ["Studio3","Solo3","Fit Pro","Інше / Ввести вручну"],
  Samsung: ["Galaxy Buds 2","Galaxy Buds 2 Pro","Інше / Ввести вручну"],
  Bose: ["QC 35 II","QC 45","700","Інше / Ввести вручну"],
  Xiaomi: ["Buds 3","Buds 4 Pro","Інше / Ввести вручну"],
};

const MODELS_CAMERA = {
  Canon: ["EOS R6","EOS R7","EOS RP","EOS 250D","Інше / Ввести вручну"],
  Nikon: ["Z6","Z7","Z50","D5600","Інше / Ввести вручну"],
  Sony: ["A7 III","A7 IV","A6400","ZV-E10","Інше / Ввести вручну"],
  Fujifilm: ["X-T3","X-T4","X-T5","X-S10","Інше / Ввести вручну"],
  Panasonic: ["Lumix S5","Lumix G9","Lumix GH6","Інше / Ввести вручну"],
  Olympus: ["OM-D E-M10","OM-D E-M5","Інше / Ввести вручну"],
  Leica: ["Q2","SL2","M10","Інше / Ввести вручну"],
};

const getBrandOptions = (type) => BRANDS_BY_TYPE[type] || [];
const getModelOptions = (type, brand) => {
  const dictByType = {
    "Смартфон": MODELS_SMARTPHONE,
    "Ноутбук": MODELS_LAPTOP,
    "Планшет": MODELS_TABLET,
    "Телевізор": MODELS_TV,
    "Ігрова консоль": MODELS_CONSOLE,
    "Смарт-годинник": MODELS_WATCH,
    "Навушники": MODELS_HEADPHONES,
    "Камера": MODELS_CAMERA,
  }[type];
  const list = dictByType ? dictByType[brand] : null;
  return list || ["Інше / Ввести вручну"];
};

const autoOS = (type, brand) => {
  if (!brand || brand === "Інше / Ввести вручну") return null;
  if (type === "Смартфон") return brand === "Apple" ? "iOS" : "Android";
  if (type === "Планшет") return brand === "Apple" ? "iPadOS" : "Android";
  if (type === "Ноутбук") return brand === "Apple" ? "macOS" : "Windows";
  if (type === "Смарт-годинник") return brand === "Apple" ? "watchOS" : "Android";
  return null;
};

export const gadgetsFields = (attrs) => {
  const a = attrs || {};
  const type = a.gadgetType || "";
  const brand = a.brand || "";

  const typeOnly = [
    { name: "gadgetType", label: "Тип гаджета", type: "select", options: GADGET_TYPES, required: true },
  ];
  if (!type) return typeOnly;

  const brandModel = [
    {
      name: "brand",
      label: "Бренд",
      type: "select",
      options: getBrandOptions(type),
      allowCustom: true,
      placeholder: "Оберіть бренд або введіть",
      showIf: (st) => st.gadgetType !== "Аксесуари",
    },
    {
      name: "brandCustom",
      label: "Власний бренд",
      type: "text",
      showIf: (st) => st.gadgetType !== "Аксесуари" && st.brand === "Інше / Ввести вручну",
    },
    {
      name: "model",
      label: "Модель",
      type: "select",
      options: getModelOptions(type, a.brand),
      allowCustom: true,
      showIf: (st) => st.gadgetType !== "Аксесуари" && !!st.brand,
      placeholder: "Оберіть модель або введіть",
    },
    {
      name: "modelCustom",
      label: "Власна модель",
      type: "text",
      showIf: (st) => st.gadgetType !== "Аксесуари" && st.model === "Інше / Ввести вручну",
    },
  ];

  const baseCommon = [
    { name: "condition", label: "Стан", type: "select", options: ["Новий","Б/в"] },
    { name: "color", label: "Колір", type: "text" },
  ];

  const smartphone = [
    { name: "os", label: "ОС", type: "select", options: ["iOS","Android","Інше"], defaultValue: autoOS(type, brand), showIf: () => type === "Смартфон" },
    { name: "storage", label: "Пам’ять (ГБ)", type: "number", showIf: () => type === "Смартфон" },
  ];

  const laptop = [
    { name: "os", label: "ОС", type: "select", options: ["Windows","macOS","Linux","Інше"], defaultValue: autoOS(type, brand), showIf: () => type === "Ноутбук" },
    { name: "cpu", label: "Процесор", type: "text", showIf: () => type === "Ноутбук" },
    { name: "ram", label: "RAM (ГБ)", type: "number", showIf: () => type === "Ноутбук" },
    { name: "storage", label: "Пам’ять (ГБ)", type: "number", showIf: () => type === "Ноутбук" },
    { name: "display", label: "Діагональ (дюйми)", type: "number", step: "0.1", showIf: () => type === "Ноутбук" },
  ];

  const tablet = [
    { name: "os", label: "ОС", type: "select", options: ["Android","iPadOS","Windows","Інше"], defaultValue: autoOS(type, brand), showIf: () => type === "Планшет" },
    { name: "ram", label: "RAM (ГБ)", type: "number", showIf: () => type === "Планшет" },
    { name: "storage", label: "Пам’ять (ГБ)", type: "number", showIf: () => type === "Планшет" },
    { name: "display", label: "Діагональ (дюйми)", type: "number", step: "0.1", showIf: () => type === "Планшет" },
  ];

  const tv = [
    { name: "diag", label: "Діагональ (дюйми)", type: "number", step: "1", showIf: () => type === "Телевізор" },
    { name: "panel", label: "Тип панелі", type: "select", options: ["LED","QLED","OLED","Mini-LED","Інше"], showIf: () => type === "Телевізор" },
    { name: "smart", label: "Smart TV", type: "select", options: ["Так","Ні"], showIf: () => type === "Телевізор" },
  ];

  const consoleFields = [
    { name: "storage", label: "Пам’ять (ГБ)", type: "number", showIf: () => type === "Ігрова консоль" },
    { name: "edition", label: "Версія / Едішн", type: "text", showIf: () => type === "Ігрова консоль" },
  ];

  const watch = [
    { name: "os", label: "ОС", type: "select", options: ["watchOS","Android","Інше"], defaultValue: autoOS(type, brand), showIf: () => type === "Смарт-годинник" },
    { name: "size", label: "Розмір корпусу (мм)", type: "number", showIf: () => type === "Смарт-годинник" },
  ];

  const headphones = [
    { name: "form", label: "Форм-фактор", type: "select", options: ["Повнорозмірні","Накладні","Вкладиші TWS","Внутрішньоканальні"], showIf: () => type === "Навушники" },
    { name: "wireless", label: "Бездротові", type: "select", options: ["Так","Ні"], showIf: () => type === "Навушники" },
  ];

  const camera = [
    { name: "mount", label: "Кріплення/Байонет", type: "text", showIf: () => type === "Камера" },
    { name: "sensor", label: "Тип сенсора", type: "select", options: ["Full Frame","APS-C","Micro 4/3","Інше"], showIf: () => type === "Камера" },
  ];

  const accessory = [
    { name: "compatibility", label: "Сумісність / Для чого", type: "text", showIf: () => type === "Аксесуари" },
  ];

  return [
    ...typeOnly,
    ...brandModel,
    ...smartphone,
    ...laptop,
    ...tablet,
    ...tv,
    ...consoleFields,
    ...watch,
    ...headphones,
    ...camera,
    ...accessory,
    ...baseCommon,
  ];
};
